/**
 * Defines a custom element based on its static tagName property
 */
export function defineCustomElement(
  CustomElementClass: CustomElementConstructor & { tagName: string },
  tagName = CustomElementClass["tagName"],
) {
  customElements.get(tagName) || customElements.define(tagName, CustomElementClass);
}
